import { navigate } from 'gatsby';
import React, { Fragment, useEffect, useState } from 'react';

import UI from '#front-credpago';

// todo: mudar chamada pra slim
import { apiSlim } from '../../services/api';
import useResizer from '../../utils/useResizer';
import { Layout } from '../index';
import listQuestions from './questions';
import * as S from './styles';

const messageError = 'Ocorreu um erro ao enviar sua respostas, Tente novamente.';

const QuestionsTenant = ({ idPerson }) => {
  const isMobile = useResizer();
  const [error, setError] = useState(false);
  const [sendingData, setSendingData] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [questions, setQuestions] = useState({
    questionOne: '',
    question2Radio: '',
    question2Text: '',
    question3Radio: '',
    question3Text: '',
    question4Radio: '',
    question4Text: '',
    question5Radio: '',
    question5Text: '',
    observation: '',
  });

  useEffect(() => {
    if (!idPerson) {
      navigate('/');
    }
  }, []);

  const handleChange = (name, value) => {
    setQuestions((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setError(false);
  };

  const nextQuestion = async () => {
    if (currentQuestion <= 6) {
      let error = false;

      if (currentQuestion === 1 && questions.questionOne === '') {
        error = true;
      }

      if (currentQuestion === 2 && questions.question2Radio === '') {
        error = true;
      }

      if (currentQuestion === 3 && questions.question3Radio === '') {
        error = true;
      }

      if (currentQuestion === 4 && questions.question4Radio === '') {
        error = true;
      }

      if (currentQuestion === 5 && questions.question5Radio === '') {
        error = true;
      }

      if (currentQuestion === 6 && questions.observation.trim() === '') {
        error = true;
      }

      if (error) {
        setError(true);
      } else {
        if (currentQuestion === 6) {
          setSendingData(true);
          setErrorMessage('');

          const params = {
            nota: questions.questionOne,
            atendimento: questions.question3Radio,
            justificativa_atendimento: questions.question3Text,
            atendimento_imobiliaria: questions.question5Radio,
            justificativa_atendimento_imobiliaria: questions.question5Text,
            facilidade: questions.question2Radio,
            justificativa_facilidade: questions.question2Text,
            contratacao: questions.question4Radio,
            justificativa_contratacao: questions.question4Text,
            observacao: questions.observation,
            versao: btoa(5),
            id_pessoa: idPerson,
          };

          try {
            const response = await apiSlim.post('marketing/pesquisa_satisfacao_inquilino', params);

            setSendingData(false);

            if (!response.data) {
              setErrorMessage(messageError);

              return;
            }

            setTimeout(() => {
              setConfirmation(true);
            }, 2000);
          } catch (error) {
            setSendingData(false);
            setErrorMessage(messageError);
          }
        } else {
          setCurrentQuestion(currentQuestion + 1);
        }
      }
    }
  };

  const backQuestion = () => {
    if (currentQuestion > 1) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  return (
    <Layout internal={true} displayImobsParceiras={false}>
      <S.Container>
        <S.Wrapper>
          <UI.Title
            level={1}
            fontWeight={700}
            splitLabel={['Pesquisa de Satisfação', '- Inquilino']}
            style={{ textAlign: 'center', marginBottom: 15 }}
          />

          {!confirmation ? (
            <>
              <UI.Description color="gray" style={{ textAlign: 'center' }}>
                A CredPago nasceu para tornar a vida das pessoas muito mais prática facilitando o acesso a moradia. Por
                isso, queremos saber como foi a sua experiência com os nossos serviços para que possamos melhorar cada
                vez mais. Responda a nossa Pesquisa de Satisfação.
              </UI.Description>

              <S.WrapperQuestion>
                {currentQuestion === 1 && (
                  <>
                    {
                      <UI.Title
                        level={3}
                        fontWeight={700}
                        label="Em uma escala de 0 a 10, qual a probabilidade de você recomendar a CredPago?"
                        style={{
                          textAlign: 'center',
                          marginTop: 30,
                          marginBottom: 15,
                        }}
                      />
                    }

                    <S.WrapperNote>
                      {listQuestions.questionOne.options.map((option) => (
                        <S.WrapperQuestionOne key={option.id} onClick={() => handleChange('questionOne', option.id)}>
                          <S.WrapperImg selected={questions.questionOne === option.id}>{option.img}</S.WrapperImg>
                          <S.Question>{option.id}</S.Question>
                        </S.WrapperQuestionOne>
                      ))}
                    </S.WrapperNote>

                    {error && questions.questionOne === '' && <S.Error>Escolha uma nota.</S.Error>}
                  </>
                )}

                {listQuestions.equalQuestion.map((question) => {
                  if (currentQuestion === question.id) {
                    return (
                      <Fragment key={question.id}>
                        <UI.Title
                          level={3}
                          fontWeight={700}
                          label={question.title}
                          style={{
                            textAlign: 'center',
                            marginTop: 30,
                            marginBottom: 15,
                          }}
                        />
                        <S.WrapperRadios>
                          <UI.Radio
                            radios={question.radios}
                            value={questions[question.valueRadio]}
                            onChange={(e) => handleChange(question.valueRadio, e.target.value)}
                          />
                        </S.WrapperRadios>

                        <S.WrapperInput>
                          <UI.Description color="gray">Caso queira, justifique sua resposta:</UI.Description>

                          <UI.InputLabel
                            style={{ width: '100%' }}
                            value={questions[question.valueText]}
                            onChange={(e) => handleChange(question.valueText, e)}
                          />
                        </S.WrapperInput>

                        {error && questions[question.valueRadio] === '' && (
                          <S.Error style={{ marginTop: 20 }}>Selecione uma opção.</S.Error>
                        )}
                      </Fragment>
                    );
                  }

                  return '';
                })}

                {currentQuestion === 6 && (
                  <>
                    <S.Question>Em poucas palavras, descreva o que motivou a escolher CredPago:</S.Question>
                    <S.WrapperTextArea>
                      <UI.TextAreaLabel
                        value={questions.observation}
                        onChange={(e) => handleChange('observation', e.target.value)}
                        id="obervation"
                      />
                    </S.WrapperTextArea>

                    {error && questions.observation === '' && (
                      <S.Error style={{ marginTop: 20 }}>Informe sua opinião.</S.Error>
                    )}
                  </>
                )}
              </S.WrapperQuestion>

              {!!errorMessage && currentQuestion === 6 && (
                <S.AlertWrapper>
                  <UI.Alert message={errorMessage} type="error" />
                </S.AlertWrapper>
              )}

              {isMobile && (
                <UI.Description color="gray" style={{ margin: '30px 0px 0px 0px' }}>
                  {currentQuestion} de 6
                </UI.Description>
              )}

              <S.WrapperButtons>
                <S.WrapperBtn>
                  <UI.Button
                    label="Voltar"
                    onClick={backQuestion}
                    type={currentQuestion === 1 ? 'link' : 'default'}
                    blocked
                  />
                </S.WrapperBtn>

                {!isMobile && (
                  <UI.Description color="gray" style={{ margin: '0px 30px 0px 30px' }}>
                    {currentQuestion} de 6
                  </UI.Description>
                )}

                <S.WrapperBtn>
                  <UI.Button
                    type={currentQuestion === 6 ? 'success' : 'primary'}
                    label={currentQuestion === 6 ? 'Enviar' : 'Avançar'}
                    onClick={nextQuestion}
                    htmlType="submit"
                    blocked
                    disabled={sendingData}
                    loading={sendingData}
                  />
                </S.WrapperBtn>
              </S.WrapperButtons>
            </>
          ) : (
            <S.WrapperConfirmation>
              <UI.Description color="gray" style={{ textAlign: 'center' }}>
                Muito obrigado por responder nossa Pesquisa de Satisfação.
              </UI.Description>

              <S.AlertWrapper style={{ marginTop: 30 }}>
                <UI.Alert message="Iremos analisar sua resposta com muito carinho!" type="success" />
              </S.AlertWrapper>
            </S.WrapperConfirmation>
          )}
        </S.Wrapper>
      </S.Container>
    </Layout>
  );
};

export default QuestionsTenant;
